import { useTranslation } from "react-i18next";
import { Users, Building2, ShieldAlert, Activity, CalendarRange, ChevronDown } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { DateInput } from "../../components/neu/DateInput";

const STATUSES = ["pending", "approved", "rejected", "cancelled"];

// حقل فلتر بأسلوب 3D Neu: عنوان ملوّن + أيقونة لتمييز كل فلتر بصرياً، مع سهم واضح على القائمة.
const Field = ({ icon: Icon, label, tone, className, forDate, testid, value, onChange, children }) => (
  <label className={`grid gap-1.5 ${className || ""}`}>
    <span className={`flex items-center gap-1.5 text-xs font-black ${tone}`}>
      <Icon className="h-4 w-4" /> {label}
    </span>
    {forDate ? (
      <DateInput data-testid={testid} value={value} onChange={onChange} />
    ) : (
      <div className="relative flex items-center rounded-2xl bg-background shadow-neu-sm transition-shadow duration-300 hover:shadow-neu focus-within:ring-2 focus-within:ring-ring">
        <select data-testid={testid} value={value} onChange={onChange}
          className="neu-select h-12 w-full appearance-none rounded-2xl bg-transparent ps-4 pe-9 text-sm font-bold text-foreground focus:outline-none">
          {children}
        </select>
        <ChevronDown className="pointer-events-none absolute end-3 h-4 w-4 text-muted-foreground" />
      </div>
    )}
  </label>
);

// شريط فلاتر صفحة العقوبات — نفس أسلوب الصفحات الرئيسية مع ألوان عناوين مميّزة.
export const PenaltyFilters = ({ filters, setFilters, types, employees, branches }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setFilters({ ...filters, [key]: e.target.value });
  const all = t("penalty.filters.all");

  return (
    <NeuCard className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="penalty-filters">
      <Field icon={Users} label={t("penalty.filters.employee")} tone="text-sky-600"
             testid="penalty-filter-employee" value={filters.user_id} onChange={set("user_id")}>
        <option value="">{all}</option>
        {employees.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
      </Field>
      <Field icon={Building2} label={t("penalty.filters.branch")} tone="text-emerald-600"
             testid="penalty-filter-branch" value={filters.branch_id} onChange={set("branch_id")}>
        <option value="">{all}</option>
        {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </Field>
      <Field icon={ShieldAlert} label={t("penalty.filters.type")} tone="text-amber-600"
             testid="penalty-filter-type" value={filters.type} onChange={set("type")}>
        <option value="">{all}</option>
        {Object.keys(types).map((key) => <option key={key} value={key}>{t(`penalty.types.${key}`)}</option>)}
      </Field>
      <Field icon={Activity} label={t("penalty.filters.status")} tone="text-violet-600"
             testid="penalty-filter-status" value={filters.status} onChange={set("status")}>
        <option value="">{all}</option>
        {STATUSES.map((key) => <option key={key} value={key}>{t(`penalty.status.${key}`)}</option>)}
      </Field>
      <Field forDate icon={CalendarRange} label={t("penalty.filters.from")} tone="text-teal-600"
             className="col-span-2 sm:col-span-1" testid="penalty-filter-from"
             value={filters.from_date} onChange={set("from_date")} />
      <Field forDate icon={CalendarRange} label={t("penalty.filters.to")} tone="text-rose-600"
             className="col-span-2 sm:col-span-1" testid="penalty-filter-to"
             value={filters.to_date} onChange={set("to_date")} />
    </NeuCard>
  );
};
